import { combineEpics } from 'redux-observable';
import boardEpic from './board';
import boosterEpic from './boosters';
// import currencyEpic from './currency';
import levelEpic from './level';
import scoreEpic from './score';
import tutorialEpic from './tutorial';
import missionEpic from './missions';

const epics = combineEpics(boardEpic, boosterEpic, levelEpic, scoreEpic, tutorialEpic, missionEpic);

export default epics;
